// Пользовательские сообщения
export const ruCustomMessages = {
    teamEfficiency: 'Эффективность продаж',
    teamMembers: 'Члены команды',
    dashboard: 'Панель управления',
    planning: 'Планирование',
    profile: 'Профиль',
    info: 'Информация',
    language: 'Язык',
    trend: 'Тренд',
    volume: 'Объем',
    myTeam: 'Моя команда',
    allTeams: 'Все команды',
    teamCalendar: 'Календарь команды',
    login: 'Войти',
    logout: 'Выйти',
    password: 'Пароль',
    user: 'Пользователь',
    users: 'Пользователи',
    suppliers: 'Поставщики',
    supplier: 'Поставщик',
    supplierName: 'Название поставщика',
    supplierContactInformation: 'Контактная информация поставщика',
    category: 'Категория',
    categoryName: 'Название категории',
    categoryDescr: 'Описание категории',
    visible: 'Флаг видимости',
    categories: 'Категории',
    products: 'Товары',
    productName: 'Название продукта',
    productDescr: 'Описание продукта',
    price: 'Цена',
    saveChanges: 'Сохранить изменения',
    cancel: 'Отмена',
    warehouse: 'The Dome',
    startFreeTrial: 'Начать бесплатный период',
    buyNow: 'Купить сейчас',
    getSource: 'Получить исходный код на GitHub',
    demoInfo: 'Это демонстрационное приложение создано с использованием следующих компонентов Kendo UI для Vue.',
    name: 'Имя',
    firstName: 'Имя',
    middleName: 'Отчество',
    lastName: 'Фамилия',
    email: 'Электронная почта',
    number: 'Номер',
    phoneNumber: 'Номер телефона',
    country: 'Страна',
    biography: 'Краткая биография',
    public: 'Включить в публичный каталог',
    team: 'ЛК',
    employee: 'Сотрудник',
    contactName: 'Контактное лицо',
    jobTitle: 'Должность',
    status: 'Статус',
    performance: 'Производительность',
    rating: 'Рейтинг',
    engagement: 'Вовлеченность',
    budget: 'Бюджет',
    contacts: 'Контакты',
    address: 'Адрес',
    phone: 'Телефон',
    gridSearch: 'Поиск по всем столбцам...',
    exportExcel: 'Экспорт в Excel',
    exportPdf: 'Экспорт в PDF',
    onSearchCategoryPlaceholder: 'Поиск категории',
    nameOfCategoryTitle: 'Название категории',
    pageTitleChangeProduct: 'Изменение продукта',
    passwordRepeat: 'Повторите пароль',

    required: "Это поле обязательно для заполнения.",
    emailValidation: "Введите корректный email.",
    'First Name should be at least 2 characters long.': 'Длина имени должна составлять не менее 2 символов.',
    productEditTitle: 'Изменение продукта',
    btnSave: 'Сохранить',
    saveError: 'Ошибка сохранения',
    createProduct: 'Создание продукта',
    addFile: 'Добавить файл',
    emptyText: 'Пусто',
    productOptions: 'Опции продукта',
    nameOptionText: 'Название опции',
    enterNameOption: 'Введите название опции',
    typeOption: 'Тип опции',
    removeOption: 'Удалить опцию',
    statusActive: 'Активный',
    statusUnactive: 'Неактивный',
    statusActiveStop: 'Приостановлен',
    closeText: 'Закрыть',
    addText: 'Добавить',
    'There is no data available custom': 'Нет доступных пользовательских данных',
    newUser: 'Новый пользователь',
    usersText: 'Пользователи',
    dateUpdate: 'Дата обновления',
    dateCreate: 'Дата создания',
    dateVeri: 'Дата верификации',
    supplierStatus: 'Статус поставщика',
    nameProduct: 'Название товара',
    basePrice: 'Базовая цена',
    categoryText: 'Категория',
    flagVisible: 'Флаг видимости',
    createText: 'Создание',
    editText: 'Редактирование',
    namePoint: 'Название пункта',
    priceText: 'Цена',
    addFileTitle: 'Добавить файл',
    addPointText: 'Добавить пункт',
    supplierText: 'Поставщик',
    supplierNameText: 'Название поставщика',
    nameTxt: 'Имя',
    productsText: 'Товары',
    selectCategory: 'Выбрать категорию',
    selectText: 'Выбрать',
    categoriesText: 'Категории',
    suppliersText: 'Поставщики',
    servicesText: 'Услуги',
    categoryNameText: 'Название категории',
    paymentsText: 'Платежи',
    ordersTxt: 'Заказы',
    productIdText: 'ID продукта',
    amountText: 'Кол-во',
    statusText: 'Статус',
    paymentDateText: 'Дата',
    createdAtText: 'Создана',
    updatedAtText: 'Обновлено',
    orderText: 'Комментарий заказа',
    clientText: 'Клиент',
    control: 'Управление',
    pending: 'Ожидание',
    cancelled: 'Отмененный',
    orderNumber: 'Номер заказа',
    client: 'Клиент',
    date: 'Дата',
    paymentType: 'Способ оплаты',
    descriptionText: 'Оцисание',
    selectStatus: 'Выберите статус',
    allText: 'Все',
    clearText: 'Очистить',
    contactInfo: 'Контактная информация',
    noData: 'Нет данных',
};

// Сообщения компонентов Kendo
export const ruComponentMessages = {
    // Grid (Таблица)
    'kendo.grid.groupPanelEmpty': 'Перетащите заголовок столбца сюда для группировки',
    'kendo.grid.noRecords': 'Нет доступных записей.',
    'kendo.grid.pagerFirstPage': 'Перейти на первую страницу',
    'kendo.grid.pagerPreviousPage': 'Перейти на предыдущую страницу',
    'kendo.grid.pagerNextPage': 'Перейти на следующую страницу',
    'kendo.grid.pagerLastPage': 'Перейти на последнюю страницу',
    'kendo.grid.pagerPage': 'Страница',
    'kendo.grid.pagerOf': 'из',
    'kendo.grid.pagerItems': 'записей',
    'kendo.grid.pagerItemsPerPage': 'записей на странице',
    'kendo.grid.pagerPageNumberInputTitle': 'Номер страницы',
    'kendo.grid.filter': 'Фильтр',
    'kendo.grid.filterEqOperator': 'Равно',
    'kendo.grid.filterNotEqOperator': 'Не равно',
    'kendo.grid.filterIsNullOperator': 'Пусто',
    'kendo.grid.filterIsNotNullOperator': 'Не пусто',
    'kendo.grid.filterIsEmptyOperator': 'Пустая строка',
    'kendo.grid.filterIsNotEmptyOperator': 'Не пустая строка',
    'kendo.grid.filterStartsWithOperator': 'Начинается с',
    'kendo.grid.filterContainsOperator': 'Содержит',
    'kendo.grid.filterNotContainsOperator': 'Не содержит',
    'kendo.grid.filterEndsWithOperator': 'Заканчивается на',
    'kendo.grid.filterGteOperator': 'Больше или равно',
    'kendo.grid.filterGtOperator': 'Больше',
    'kendo.grid.filterLteOperator': 'Меньше или равно',
    'kendo.grid.filterLtOperator': 'Меньше',
    'kendo.grid.filterIsTrue': 'истина',
    'kendo.grid.filterIsFalse': 'ложь',
    'kendo.grid.filterBooleanAll': '(Все)',
    'kendo.grid.filterAfterOrEqualOperator': 'После или равно',
    'kendo.grid.filterAfterOperator': 'После',
    'kendo.grid.filterBeforeOperator': 'До',
    'kendo.grid.filterBeforeOrEqualOperator': 'До или равно',
    'kendo.grid.filterFilterButton': 'Фильтровать',
    'kendo.grid.filterClearButton': 'Очистить',
    'kendo.grid.filterAndLogic': 'И',
    'kendo.grid.filterOrLogic': 'Или',
    'kendo.grid.filterDateToggle': 'Показать календарь',
    'kendo.grid.filterDateToday': 'Сегодня',
    'kendo.grid.filterNumericDecrement': 'Уменьшить значение',
    'kendo.grid.filterNumericIncrement': 'Увеличить значение',
    'kendo.grid.loading': 'Загрузка',
    'kendo.grid.sort': 'Сортировка',
    'kendo.grid.columnMenu': 'Меню столбца',
    'kendo.grid.columns': 'Столбцы',
    'kendo.grid.lock': 'Закрепить',
    'kendo.grid.unlock': 'Открепить',
    'kendo.grid.stick': 'Прикрепить',
    'kendo.grid.unstick': 'Открепить',
    'kendo.grid.setColumnPosition': 'Установить позицию столбца',
    'kendo.grid.sortAscending': 'Сортировать по возрастанию',
    'kendo.grid.sortDescending': 'Сортировать по убыванию',
    'kendo.grid.columnsApply': 'Применить',
    'kendo.grid.columnsReset': 'Сбросить',
    'kendo.grid.sortable': 'Сортируемый',
    'kendo.grid.sortedAscending': 'Отсортировано по возрастанию',
    'kendo.grid.sortedDescending': 'Отсортировано по убыванию',
    // DropDowns (Выпадающие списки)
    'kendo.autocomplete.noDataText': 'Данные не найдены',
    'kendo.autocomplete.clearTitle': 'Очистить',
    'kendo.combobox.noDataText': 'Данные не найдены',
    'kendo.combobox.clearTitle': 'Очистить',
    'kendo.dropdownlist.noDataText': 'Данные не найдены',
    'kendo.dropdownlist.clearTitle': 'Очистить',

    // Calendar (Календарь)
    'kendo.calendar.today': 'СЕГОДНЯ',

    // TextBox (Текстовое поле)
    'kendo.textbox.clearTitle': 'Очистить',

    // DatePicker (Выбор даты)
    'kendo.datepicker.today': 'СЕГОДНЯ',
    'kendo.datepicker.toggle': 'Показать календарь',

    // DateInput (Ввод даты)
    'kendo.dateinput.increment': 'Увеличить значение',
    'kendo.dateinput.decrement': 'Уменьшить значение',

    // NumericTextBox (Числовое поле)
    'kendo.numerictextbox.increment': 'Увеличить значение',
    'kendo.numerictextbox.decrement': 'Уменьшить значение',

    // DateTimePicker (Выбор даты и времени)
    'kendo.datetimepicker.dateTab': 'Дата',
    'kendo.datetimepicker.dateTabLabel': 'Вкладка даты',
    'kendo.datetimepicker.timeTab': 'Время',
    'kendo.datetimepicker.timeTabLabel': 'Вкладка времени',
    'kendo.datetimepicker.toggle': 'Показать/скрыть',
    'kendo.datetimepicker.accept': 'Установить',
    'kendo.datetimepicker.acceptLabel': 'Установить',
    'kendo.datetimepicker.cancel': 'Отмена',
    'kendo.datetimepicker.cancelLabel': 'Отмена',
    'kendo.datetimepicker.now': 'СЕЙЧАС',
    'kendo.datetimepicker.nowLabel': 'Выбрать текущее время',
    'kendo.datetimepicker.today': 'СЕГОДНЯ',
    'kendo.datetimepicker.prevButtonTitle': 'Перейти к предыдущему виду',
    'kendo.datetimepicker.nextButtonTitle': 'Перейти к следующему виду',

    // TimePicker (Выбор времени)
    'kendo.timepicker.accept': 'Установить',
    'kendo.timepicker.acceptLabel': 'Установить',
    'kendo.timepicker.cancel': 'Отмена',
    'kendo.timepicker.cancelLabel': 'Отмена',
    'kendo.timepicker.now': 'Сейчас',
    'kendo.timepicker.nowLabel': 'Сейчас',
    'kendo.timepicker.toggle': 'Показать/скрыть список времени',

    // FileSelect (Выбор файла)
    'kendo.fileselect.cancel': 'Отмена',
    'kendo.fileselect.clearSelectedFiles': 'Очистить',
    'kendo.fileselect.dropFilesHere': 'Перетащите файлы сюда для загрузки',
    'kendo.fileselect.externalDropFilesHere': 'Перетащите файлы сюда для загрузки',
    'kendo.fileselect.filesBatchStatus': 'файлов',
    'kendo.fileselect.filesBatchStatusFailed': 'файлов не удалось загрузить.',
    'kendo.fileselect.filesBatchStatusUploaded': 'файлов успешно загружено.',
    'kendo.fileselect.fileStatusFailed': 'Не удалось загрузить файл.',
    'kendo.fileselect.fileStatusUploaded': 'Файл успешно загружен.',
    'kendo.fileselect.headerStatusPaused': 'Приостановлено',
    'kendo.fileselect.headerStatusUploaded': 'Готово',
    'kendo.fileselect.headerStatusUploading': 'Загрузка...',
    'kendo.fileselect.invalidFileExtension': 'Недопустимый тип файла.',
    'kendo.fileselect.invalidMaxFileSize': 'Файл слишком большой.',
    'kendo.fileselect.invalidMinFileSize': 'Файл слишком маленький.',
    'kendo.fileselect.remove': 'Удалить',
    'kendo.fileselect.retry': 'Повторить',
    'kendo.fileselect.select': 'Выбрать файлы...',
    'kendo.fileselect.uploadSelectedFiles': 'Загрузить файлы',

    // Scheduler (Планировщик)
    "kendo.scheduler.agendaViewTitle": "Повестка дня",
    "kendo.scheduler.allDay": "весь день",
    "kendo.scheduler.allEvents": "Все события",
    "kendo.scheduler.calendarToday": "СЕГОДНЯ",
    "kendo.scheduler.cancel": "Отмена",
    "kendo.scheduler.save": "Сохранить",
    "kendo.scheduler.editorEventTitle": "Название",
    "kendo.scheduler.editorEventStart": "Начало",
    "kendo.scheduler.editorEventStartTimeZone": "Часовой пояс начала",
    "kendo.scheduler.editorEventEnd": "Окончание",
    "kendo.scheduler.editorEventEndTimeZone": "Часовой пояс окончания",
    "kendo.scheduler.dateHeader": "Дата",
    "kendo.scheduler.dayViewTitle": "День",
    "kendo.scheduler.deleteConfirmation": "Вы уверены, что хотите удалить это событие?",
    "kendo.scheduler.deleteDialogTitle": "Удалить событие",
    "kendo.scheduler.deleteOccurrence": "Удалить текущее повторение",
    "kendo.scheduler.deleteRecurringConfirmation": "Вы хотите удалить только это повторение события или всю серию?",
    "kendo.scheduler.deleteRecurringDialogTitle": "Удалить повторяющийся элемент",
    "kendo.scheduler.deleteSeries": "Удалить серию",
    "kendo.scheduler.deleteTitle": "Удалить",
    "kendo.scheduler.destroy": "Удалить",
    "kendo.scheduler.editOccurrence": "Редактировать текущее повторение",
    "kendo.scheduler.editorEventAllDay": "Событие на весь день",
    "kendo.scheduler.editorEventDescription": "Описание",
    "kendo.scheduler.editorEventSeparateTimeZones": "Разные часовые пояса для начала и окончания",
    "kendo.scheduler.editorEventTimeZone": "Указать часовой пояс",
    "kendo.scheduler.editorTitle": "Событие",
    "kendo.scheduler.editRecurringConfirmation": "Вы хотите редактировать только это повторение события или всю серию?",
    "kendo.scheduler.editRecurringDialogTitle": "Редактировать повторяющийся элемент",
    "kendo.scheduler.editSeries": "Редактировать серию",
    "kendo.scheduler.eventHeader": "Событие",
    "kendo.scheduler.monthViewTitle": "Месяц",
    "kendo.scheduler.multiDayViewTitle": "Несколько дней",
    "kendo.scheduler.nextTitle": "Следующий",
    "kendo.scheduler.previousTitle": "Предыдущий",
    "kendo.scheduler.recurrenceEditorDailyInterval": "дней",
    "kendo.scheduler.recurrenceEditorDailyRepeatEvery": "Повторять каждые",
    "kendo.scheduler.recurrenceEditorEndAfter": "После",
    "kendo.scheduler.recurrenceEditorEndLabel": "Окончание",
    "kendo.scheduler.recurrenceEditorEndNever": "Никогда",
    "kendo.scheduler.recurrenceEditorEndOccurrence": "повторений",
    "kendo.scheduler.recurrenceEditorEndOn": "До",
    "kendo.scheduler.recurrenceEditorFrequenciesDaily": "Ежедневно",
    "kendo.scheduler.recurrenceEditorFrequenciesMonthly": "Ежемесячно",
    "kendo.scheduler.recurrenceEditorFrequenciesNever": "Никогда",
    "kendo.scheduler.recurrenceEditorFrequenciesWeekly": "Еженедельно",
    "kendo.scheduler.recurrenceEditorFrequenciesYearly": "Ежегодно",
    "kendo.scheduler.recurrenceEditorMonthlyDay": "День",
    "kendo.scheduler.recurrenceEditorMonthlyInterval": "месяцев",
    "kendo.scheduler.recurrenceEditorMonthlyRepeatEvery": "Повторять каждые",
    "kendo.scheduler.recurrenceEditorMonthlyRepeatOn": "Повторять в",
    "kendo.scheduler.recurrenceEditorOffsetPositionsFirst": "Первый",
    "kendo.scheduler.recurrenceEditorOffsetPositionsFourth": "Четвертый",
    "kendo.scheduler.recurrenceEditorOffsetPositionsLast": "Последний",
    "kendo.scheduler.recurrenceEditorOffsetPositionsSecond": "Второй",
    "kendo.scheduler.recurrenceEditorOffsetPositionsThird": "Третий",
    "kendo.scheduler.recurrenceEditorRepeat": "Повторять",
    "kendo.scheduler.recurrenceEditorWeekdaysDay": "День",
    "kendo.scheduler.recurrenceEditorWeekdaysWeekday": "Рабочий день",
    "kendo.scheduler.recurrenceEditorWeekdaysWeekendday": "Выходной день",
    "kendo.scheduler.recurrenceEditorWeeklyInterval": "недель",
    "kendo.scheduler.recurrenceEditorWeeklyRepeatEvery": "Повторять каждые",
    "kendo.scheduler.recurrenceEditorWeeklyRepeatOn": "Повторять по",
    "kendo.scheduler.recurrenceEditorYearlyInterval": "лет",
    "kendo.scheduler.recurrenceEditorYearlyOf": "месяца",
    "kendo.scheduler.recurrenceEditorYearlyRepeatEvery": "Повторять каждые",
    "kendo.scheduler.recurrenceEditorYearlyRepeatOn": "Повторять в",
    "kendo.scheduler.showFullDay": "Показать полный день",
    "kendo.scheduler.showWorkDay": "Показать рабочие часы",
    "kendo.scheduler.timeHeader": "Время",
    "kendo.scheduler.timelineMonthViewTitle": "Временная шкала месяца",
    "kendo.scheduler.timelineViewTitle": "Временная шкала",
    "kendo.scheduler.timelineWeekViewTitle": "Временная шкала недели",
    "kendo.scheduler.today": "Сегодня",
    "kendo.scheduler.weekViewTitle": "Неделя",
    "kendo.scheduler.workWeekViewTitle": "Рабочая неделя",

    // RecurrenceEditor (Редактор повторений)
    "kendo.recurrenceeditor.dailyInterval": "дней",
    // RecurrenceEditor (продолжение)
    "kendo.recurrenceeditor.dailyRepeatEvery": "Повторять каждые",
    "kendo.recurrenceeditor.end": "Окончание",
    "kendo.recurrenceeditor.endAfter": "После",
    "kendo.recurrenceeditor.endLabel": "Окончание",
    "kendo.recurrenceeditor.endNever": "Никогда",
    "kendo.recurrenceeditor.endOccurrence": "повторений",
    "kendo.recurrenceeditor.endOn": "До",
    "kendo.recurrenceeditor.monthly": "Ежемесячно",
    "kendo.recurrenceeditor.monthlyInterval": "месяцев",
    "kendo.recurrenceeditor.monthlyRepeatEvery": "Повторять каждые",
    "kendo.recurrenceeditor.monthlyRepeatOn": "Повторять в",
    "kendo.recurrenceeditor.never": "Никогда",
    "kendo.recurrenceeditor.offsetPositionsFirst": "первый",
    "kendo.recurrenceeditor.offsetPositionsFourth": "четвертый",
    "kendo.recurrenceeditor.offsetPositionsLast": "последний",
    "kendo.recurrenceeditor.offsetPositionsSecond": "второй",
    "kendo.recurrenceeditor.offsetPositionsThird": "третий",
    "kendo.recurrenceeditor.repeat": "Повторять",
    "kendo.recurrenceeditor.weekly": "Еженедельно",
    "kendo.recurrenceeditor.weeklyInterval": "недель",
    "kendo.recurrenceeditor.weeklyRepeatEvery": "Повторять каждые",
    "kendo.recurrenceeditor.weeklyRepeatOn": "Повторять по",
    "kendo.recurrenceeditor.yearly": "Ежегодно",
    "kendo.recurrenceeditor.yearlyInterval": "лет",
    "kendo.recurrenceeditor.yearlyRepeatEvery": "Повторять каждые",
    "kendo.recurrenceeditor.yearlyRepeatOn": "Повторять в",

    // Upload (Загрузка файлов)
    "kendo.upload.cancel": "Отмена",
    "kendo.upload.clearSelectedFiles": "Очистить",
    "kendo.upload.dropFilesHere": "Перетащите файлы сюда для загрузки",
    "kendo.upload.headerStatusUploaded": "Готово",
    "kendo.upload.headerStatusUploading": "Загрузка...",
    "kendo.upload.invalidFileExtension": "Недопустимый тип файла.",
    "kendo.upload.invalidMaxFileSize": "Размер файла слишком большой.",
    "kendo.upload.invalidMinFileSize": "Размер файла слишком маленький.",
    "kendo.upload.remove": "Удалить",
    "kendo.upload.retry": "Повторить",
    "kendo.upload.select": "Выбрать файлы...",
    "kendo.upload.uploadSelectedFiles": "Загрузить файлы",

    // Validator (Валидация)
    "kendo.validator.accept": "Пожалуйста, примите",
    "kendo.validator.email": "Пожалуйста, введите правильный email",
    "kendo.validator.equalto": "Значения должны совпадать",
    "kendo.validator.max": "Пожалуйста, введите значение, меньшее или равное {0}",
    "kendo.validator.min": "Пожалуйста, введите значение, большее или равное {0}",
    "kendo.validator.pattern": "Пожалуйста, проверьте это поле",
    "kendo.validator.required": "Это поле обязательно для заполнения",
    "kendo.validator.step": "Пожалуйста, введите корректное значение",
    "kendo.validator.url": "Пожалуйста, введите правильный URL",

    // Editor (Редактор)
    "kendo.editor.addColumnLeft": "Добавить столбец слева",
    "kendo.editor.addColumnRight": "Добавить столбец справа",
    "kendo.editor.addRowAbove": "Добавить строку выше",
    "kendo.editor.addRowBelow": "Добавить строку ниже",
    "kendo.editor.alignCenter": "По центру",
    "kendo.editor.alignLeft": "По левому краю",
    "kendo.editor.alignRight": "По правому краю",
    "kendo.editor.bold": "Жирный",
    "kendo.editor.createLink": "Вставить ссылку",
    "kendo.editor.createTable": "Вставить таблицу",
    "kendo.editor.deleteColumn": "Удалить столбец",
    "kendo.editor.deleteRow": "Удалить строку",
    "kendo.editor.dialogCancel": "Отмена",
    "kendo.editor.dialogInsert": "Вставить",
    "kendo.editor.dialogOk": "ОК",
    "kendo.editor.dialogUpdate": "Обновить",
    "kendo.editor.italic": "Курсив",
    "kendo.editor.justifyCenter": "Выровнять по центру",
    "kendo.editor.justifyFull": "По ширине",
    "kendo.editor.justifyLeft": "Выровнять по левому краю",
    "kendo.editor.justifyRight": "Выровнять по правому краю",
    "kendo.editor.linkOpenInNewWindow": "Открыть в новом окне",
    "kendo.editor.linkText": "Текст",
    "kendo.editor.linkToolTip": "Подсказка",
    "kendo.editor.linkWebAddress": "Веб-адрес",
    "kendo.editor.orderList": "Нумерованный список",
    "kendo.editor.strikethrough": "Зачеркнутый",
    "kendo.editor.subscript": "Нижний индекс",
    "kendo.editor.superscript": "Верхний индекс",
    "kendo.editor.underline": "Подчеркнутый",
    "kendo.editor.unlink": "Удалить ссылку",
    "kendo.editor.unorderedList": "Маркированный список",
    "selectParentCategory": "Выберите родительскую категорию",
    "requiredOption": "Обязательное поле",
    "passwordMoreCharacters": "Пароль должен быть не менее 8 символов",
    "passwordIsNotEqual": "Пароли не совпадают",
    "multy": "Множественный",
    "single": "Одиночный",
    "deleteError": "Ошибка удаления",
    "selectAnotherFile": "Выберите другой формат файла",
    "orderNumber": "Номер заказа",
    "dateText": "Дата",
    "paymentTypeText": "Способ оплаты",
    "textDescription": "Описание",
    "textPrice": "Цена",
    "productText": "Продукты",
    "StatusText": "Статус",
    "SelectStatus": "Выберите статус",
    "AllText": "Все",
    "clearTExt": "Очистить",
    "cancelText": "Отмена",
    "deteleteText": "Удалить",
    "nameText": "Имя",
    "contactInfoText": "Контактная информация",
    "error": "ошибка",
    "selectUserText": "Выберите пользователя"
};